import { CmsValue } from 'core/type/BootstrapConfig.types';
import { DispatchProps } from 'component/page/search/SortAndFilter/SortAndFilterOverlay/SortAndFilterOverlay.selectors';
import { Sort } from 'gql/autogen/Sort';
import { FilterState } from 'component/common/Filter/Filter.types';
import { Pagination } from 'gql/autogen/Pagination';
import { createSelector } from '@reduxjs/toolkit';
import { EmptyResultInfo, selectFilterState, selectResultInfoFromSearchState, selectSortState } from 'component/page/search/store/search.selectors';

export interface OwnProps {
    cms: CmsValue;
    onClose: () => void;
}

interface StateProps {
    sort: Sort;
    filter: FilterState;
    page: Pagination;
}

export const mapStateToProps = createSelector(selectResultInfoFromSearchState, selectSortState, selectFilterState, (resultInfo, sort, filter) => {
    const page = resultInfo.pagination || EmptyResultInfo.pagination;
    return {
        page,
        sort,
        filter,
    };
});

export type CategoryBottomSheetProps = OwnProps & StateProps & DispatchProps;
